import {
  IconMenuButton,
  stenaDots,
  ActionMenu,
  ActionMenuItem,
} from "@stenajs-webui/elements";
import { Popover } from "@stenajs-webui/tooltip";
import { Rebate } from "../types/types";
import { RebateProgress } from "@/gql/graphql";

interface Props {
  rebate: RebateProgress;
  onUpdateExpectedVolume: (rebate: RebateProgress) => void;
}

export const RebateTableActionMenu = ({
  rebate,
  onUpdateExpectedVolume,
}: Props) => {
  return (
    <Popover
      placement={"left"}
      disablePadding
      trigger={"click"}
      renderTrigger={(props) => <IconMenuButton icon={stenaDots} {...props} />}
    >
      <ActionMenu>
        <ActionMenuItem
          label={"Change expected volume"}
          onClick={() => onUpdateExpectedVolume(rebate)}
        />
      </ActionMenu>
    </Popover>
  );
};
